<script>
export default {
  asyncData ({ redirect }) {
    return redirect('/404')
  }
}
</script>
